var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3807 3L3.74348 14.4127L3 21L9.27447 20.0988L20.9996 8.49934L15.3807 3ZM12.9024 6.49951L15.3807 4.06968L19.9104 8.50163L17.4268 10.9597L12.9024 6.49951ZM4.4732 14.7672L12.3578 7.03397L14.3687 9.01779L7.38976 15.9741L7.93054 16.5132L14.9125 9.55377L16.8837 11.4972L8.91497 19.3799L3.87046 20.1049L4.4732 14.7672Z",
    fill: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7065_114864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3807 3L3.74348 14.4127L3 21L9.27447 20.0988L20.9996 8.49934L15.3807 3ZM12.9024 6.49951L15.3807 4.06968L19.9104 8.50163L17.4268 10.9597L12.9024 6.49951ZM4.4732 14.7672L12.3578 7.03397L14.3687 9.01779L7.38976 15.9741L7.93054 16.5132L14.9125 9.55377L16.8837 11.4972L8.91497 19.3799L3.87046 20.1049L4.4732 14.7672Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7065_114864)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D0D0D0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.babb530c672064e8f509404c27fc51f1.svg";
export { ForwardRef as ReactComponent };